export const MAX_ADDITIONAL_RECIPIENTS = 20;

export const RECIPIENT_ERRORS = {
  wrongDomain: 'Only @samsung.com and @cheil.com addresses are allowed.',
  invalidFormat: 'Enter a valid email address.',
  limitReached: `You can add up to ${MAX_ADDITIONAL_RECIPIENTS} recipients.`,
  submitBlocked: 'Fix or remove the invalid address before running the test.',
  duplicate: 'This email address has already been added.'
} as const;

const EMAIL_FORMAT_REGEX = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/;
const ALLOWED_DOMAIN_REGEX = /@(samsung|cheil)\.com$/;
const SEPARATOR_REGEX = /[,;\s]+/;

export const RECIPIENT_SEPARATOR_KEYS = ['Enter', ' ', ',', ';'];

export const hasRecipientSeparator = (text: string) => SEPARATOR_REGEX.test(text);

export interface ParsedRecipients {
  added: string[];
  remaining: string;
  errors: string[];
}

export const parseRecipients = (input: string, existingRecipients: string[]): ParsedRecipients => {
  const addresses = input.split(SEPARATOR_REGEX).filter((address) => address !== '');
  const takenAddresses = new Set(existingRecipients.map((recipient) => recipient.toLowerCase()));

  const added: string[] = [];
  const kept: string[] = [];
  const errors = new Set<string>();

  for (const address of addresses) {
    if (!EMAIL_FORMAT_REGEX.test(address)) {
      kept.push(address);
      errors.add(RECIPIENT_ERRORS.invalidFormat);
      continue;
    }

    if (!ALLOWED_DOMAIN_REGEX.test(address)) {
      kept.push(address);
      errors.add(RECIPIENT_ERRORS.wrongDomain);
      continue;
    }

    if (takenAddresses.has(address.toLowerCase())) {
      errors.add(RECIPIENT_ERRORS.duplicate);
      continue;
    }

    if (existingRecipients.length + added.length >= MAX_ADDITIONAL_RECIPIENTS) {
      kept.push(address);
      errors.add(RECIPIENT_ERRORS.limitReached);
      continue;
    }

    added.push(address);
    takenAddresses.add(address.toLowerCase());
  }

  return { added, remaining: kept.join(', '), errors: [...errors] };
};
